export default {
	props: {
		expanded: {
			type: Boolean,
			required: true
		},

		initial: {
			type: Boolean,
			required: true
		},

		labelledBy: {
			type: String,
			required: true
		},

		toggle: {
			type: Function,
			required: true
		},

		open: {
			type: Function,
			required: true
		},

		selectDown: {
			type: Function,
			required: true
		},

		selectUp: {
			type: Function,
			required: true
		},

		oneOption: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		toggleFocus(focusButton = false) {
			if (this.initial || focusButton) {
				this.$refs.button.focus();
			} else {
				this.$refs.button.blur();
			}
		}
	},

	mounted() {
		this.toggleFocus();
	},

	updated() {
		this.toggleFocus();
	}
};
